import React from "react"

import type { ServerResponseContext } from "~/lib/server"

import { sites } from "~/config/sites"

import { LoaderProvider } from "~/providers/LoaderProvider"

export interface StaticLoaderProviderProps {
  children: React.ReactNode
  /**
   * Select site with the given locale.
   * This is mainly used by tests to change the selected site.
   */
  locale?: string
}

/**
 * Used to provide placeholder loader values when Gatsby is generating a "static" page
 * before server rendering.
 */
export function StaticLoaderProvider({ children, locale }: StaticLoaderProviderProps) {
  const site = (() => {
    // Look for a site with the given locale.
    if (locale) {
      const site = sites.find(site => locale === site.locale)
      if (site) return site
    }

    // Return default site.
    return sites.find(site => "us" === site.handle)
  })()
  if (!site) throw new Error("No site could be resolved in StaticLoaderProvider.")

  const staticRootLoaderData: ServerResponseContext["rootData"] = {
    seo: {},
    geofencing: null,
    storefrontApiVersion: "2024-07",
    shop: {
      handle: "production",
      shopifyDomain: "bared-footwear-au.myshopify.com",
      checkoutDomain: "checkout.baredfootwear.com",
      storefrontId: "36092",
      publicStorefrontToken: "59c55f77c2ca07bbaec00c9ca19b65c9",
    },
  }

  const staticSiteLoaderData: ServerResponseContext["siteLoaderData"] = {
    sites,
    site,
    localSite: site,
    viewerContext: { countryCode: "AU", countryName: "Australia" },
  }

  return (
    <LoaderProvider rootLoaderData={staticRootLoaderData} siteLoaderData={staticSiteLoaderData}>
      {children}
    </LoaderProvider>
  )
}
